import Subtitle from "@base/Subtitle/Subtitle"

export default Subtitle;
